import React, { useState } from 'react';
import { material } from '../../../library/material';
import { useForm } from 'react-hook-form';
import { saveCrmNotesData } from '../../../services/PlatformCrmService';
import Snackbar from '../../toastrmessage/Snackbar';

function AddNotesDialog(props) {

    const { openAddNotesDialog, setOpenAddNotesDialog, getNotesDataByPlatformCrmId } = props;
    const { register, handleSubmit, reset } = useForm({ mode: "onTouched" });
    const [openSnackBar, setOpenSnackBar] = useState({
        "action": false,
        "type": "",
        "message": "",
    });

    const saveNotes = (data) => {
        const payload = {
            platformCrmId: openAddNotesDialog.platformCrmId,
            ...data
        }
        saveCrmNotesData(payload)
            .then((resp) => {
                setOpenSnackBar({
                    "action": true,
                    "type": "success",
                    "message": resp.data.messages,
                })
                getNotesDataByPlatformCrmId();
                reset({ notes: "" });
                setOpenAddNotesDialog({ action: false, platformCrmId: null });
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.data.info,
                    })
                } else {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.messages,
                    })
                }
            })
    };

    const handleClose = () => {
        setOpenAddNotesDialog({ action: false, platformCrmId: null });
    };

    return (
        <div>
            <material.Dialog open={openAddNotesDialog.action} maxWidth="md" fullWidth hideBackdrop>
                <material.DialogTitle>Add Notes</material.DialogTitle>
                <material.DialogContent>
                    <material.TextField
                        required
                        variant="standard"
                        label="Notes"
                        type="text"
                        fullWidth
                        multiline
                        rows={3}
                        {...register("notes", { require: true })}
                    />
                </material.DialogContent>
                <material.DialogActions>
                    <material.Button onClick={handleClose} variant="outlined" sx={{ textTransform: "none" }} color='error' startIcon={<material.CloseIcon />}>Cancel</material.Button>
                    <material.Button onClick={handleSubmit(saveNotes)} variant="outlined" sx={{ textTransform: "none" }} color='success' startIcon={<material.DoneIcon />}>Save</material.Button>
                </material.DialogActions>
            </material.Dialog>
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
        </div>
    );
}

export default AddNotesDialog;